export const onewaySearchId = {
  body: {
    BookingDetails: {
      sourceLat: "25.248664",
      sourceLng: "55.352916",
      destinationLat: "25.228813942344",
      destinationLng: "55.28827531781",
      sourcePlaceName: "Dubai Airport (DXB),Dubai,United Arab Emirates",
      destinationPlaceName: "Dubai Park,,Dubai AE",
      date: "2024-08-15",
      time: "10:00",
      passenger: "1",
    },
  },

  response: {
    sId: "SE-0824-EUUJR-OW",
  },
};

export const onewayVehicleWithPrice = {
  response: {
    success: true,
    km: 31.703998,
    vehicleWithPriceArray: [
      {
        id: "6426d46c7cfcc6b82fc1c23f",
        vehicleName: "Corolla",
        vehicleType: "STANDARD SEDAN",
        description: "Corolla, Toyota Prius, Camry, Ford Taurus or similar",
        price: 94,
        image:
          "https://res.cloudinary.com/dspmukglv/image/upload/v1680266348/vehicleImages/wqeqnbq1botsobbpuqyu.png",
        vehicleId: "3d8e08cd-6ffc-457b-a59b-e99206e3f7e5",
        unit: "USD",
        passengeCount: 3,
        luggageCount: 2,
      },
      {
        id: "6426d4c57cfcc6b82fc1c246",
        vehicleName: "E class",
        vehicleType: "PREMIUM SEDAN",
        description:
          "Mercedes E Class, BMW 5 Series, Audi A6, VW Passat, Lexus or similar",
        price: 117,
        image:
          "https://res.cloudinary.com/dspmukglv/image/upload/v1680266436/vehicleImages/q5qmj7zssf0znf77r7jy.png",
        vehicleId: "3d8e08cd-6ffc-457b-a59b-e99206e3f7e5",
        unit: "USD",
        passengeCount: 3,
        luggageCount: 2,
      },
      {
        id: "6426d4fd7cfcc6b82fc1c24e",
        vehicleName: "VW Caravelle",
        vehicleType: "ECONOMY VAN",
        description:
          "Opel Vivaro, Ford, Volkswagen Caravelle, Honda Odyssey or similar",
        price: 137,
        image:
          "https://res.cloudinary.com/dspmukglv/image/upload/v1680266492/vehicleImages/tiyfdlzdgffmz4aglbgp.png",
        vehicleId: "3d8e08cd-6ffc-457b-a59b-e99206e3f7e5",
        unit: "USD",
        passengeCount: 5,
        luggageCount: 5,
      },
      {
        id: "6426d7a57cfcc6b82fc1c273",
        vehicleName: "Escalade",
        vehicleType: "PREMIUM VAN",
        description:
          "Mercedes Viano/V Class, Cadillac Escalade, Toyota Alphard, Chevrolet Suburban, GMC or similar",
        price: 149,
        image:
          "https://res.cloudinary.com/dspmukglv/image/upload/v1680267172/vehicleImages/p180pdqrxvfjcr2vburt.png",
        vehicleId: "3d8e08cd-6ffc-457b-a59b-e99206e3f7e5",
        unit: "USD",
        passengeCount: 5,
        luggageCount: 5,
      },
      {
        id: "6426d5c37cfcc6b82fc1c260",
        vehicleName: "S Class",
        vehicleType: "LUXURY SEDAN",
        description: "Mercedes S Class, BMW 7 Series, Audi A8 or similar",
        price: 178,
        image:
          "https://res.cloudinary.com/dspmukglv/image/upload/v1680266691/vehicleImages/i0lj7rgpfnfizjqtb9ef.png",
        vehicleId: "3d8e08cd-6ffc-457b-a59b-e99206e3f7e5",
        unit: "USD",
        passengeCount: 3,
        luggageCount: 2,
      },
    ],
  },
};

export const onewaybookingCode = {
  body: {
    vehicleId: "6426d4fd7cfcc6b82fc1c24e",
    passengerDetails: {
      firstname: "test first name",
      lastname: "test last name",
      email: "appdocstest@email.com",
      phone: "6589455236",
      country: "India",
      dial_code: "+91",
      flightOrTrain: "TK1372",
      reference: "9978556897844",
      specialRequest: "no special request",
    },
  },
  response: {
    msg: "Booking created successfully",
    bookingId: "D0824-2294",
  },
};

export const onewaySearchIdCodeImplementation = {
  nodejs_Axios: `
const axios = require('axios');
let data = JSON.stringify({
  "BookingDetails": {
    "sourceLat": "25.248664",
    "sourceLng": "55.352916",
    "destinationLat": "25.228813942344",
    "destinationLng": "55.28827531781",
    "sourcePlaceName": "Dubai Airport (DXB),Dubai,United Arab Emirates",
    "destinationPlaceName": "Dubai Park,,Dubai AE",
    "date": "2024-08-15",
    "time": "10:00",
    "passenger": "1"
  }
});

let config = {
  method: 'post',
  maxBodyLength: Infinity,
  url: 'https://testapi.drivado.com/api/v1/api/searchIdGenerateOneway?email=W1user1@email.com',
  headers: { 
    'apikey': 'iL9e30CjZfRok2FuH6KC1xuqCa7C3K', 
    'Content-Type': 'application/json'
  },
  data : data
};

axios.request(config)
.then((response) => {
  console.log(JSON.stringify(response.data));
})
.catch((error) => {
  console.log(error);
});
`,
  python: `
import requests
import json

url = "https://testapi.drivado.com/api/v1/api/searchIdGenerateOneway?email=W1user1@email.com"

payload = json.dumps({
  "BookingDetails": {
    "sourceLat": "25.248664",
    "sourceLng": "55.352916",
    "destinationLat": "25.228813942344",
    "destinationLng": "55.28827531781",
    "sourcePlaceName": "Dubai Airport (DXB),Dubai,United Arab Emirates",
    "destinationPlaceName": "Dubai Park,,Dubai AE",
    "date": "2024-08-15",
    "time": "10:00",
    "passenger": "1"
  }
})
headers = {
  'apikey': 'iL9e30CjZfRok2FuH6KC1xuqCa7C3K',
  'Content-Type': 'application/json'
}

response = requests.request("POST", url, headers=headers, data=payload)

print(response.text)
`,
  go: `
package main

import (
  "bytes"
  "encoding/json"
  "fmt"
  "net/http"
)

func main() {
  url := "https://testapi.drivado.com/api/v1/api/searchIdGenerateOneway?email=W1user1@email.com"

  payload := map[string]interface{}{
    "BookingDetails": map[string]string{
      "sourceLat": "25.248664",
      "sourceLng": "55.352916",
      "destinationLat": "25.228813942344",
      "destinationLng": "55.28827531781",
      "sourcePlaceName": "Dubai Airport (DXB),Dubai,United Arab Emirates",
      "destinationPlaceName": "Dubai Park,,Dubai AE",
      "date": "2024-08-15",
      "time": "10:00",
      "passenger": "1"
    }
  }
  jsonData, _ := json.Marshal(payload)

  req, _ := http.NewRequest("POST", url, bytes.NewBuffer(jsonData))
  req.Header.Set("apikey", "iL9e30CjZfRok2FuH6KC1xuqCa7C3K")
  req.Header.Set("Content-Type", "application/json")

  client := &http.Client{}
  resp, _ := client.Do(req)
  defer resp.Body.Close()

  var result map[string]interface{}
  json.NewDecoder(resp.Body).Decode(&result)

  fmt.Println(result)
}
`,
  curl: `
curl --location --request POST 'https://testapi.drivado.com/api/v1/api/searchIdGenerateOneway?email=W1user1@email.com' \\
--header 'apikey: iL9e30CjZfRok2FuH6KC1xuqCa7C3K' \\
--header 'Content-Type: application/json' \\
--data-raw '{
  "BookingDetails": {
    "sourceLat": "25.248664",
    "sourceLng": "55.352916",
    "destinationLat": "25.228813942344",
    "destinationLng": "55.28827531781",
    "sourcePlaceName": "Dubai Airport (DXB),Dubai,United Arab Emirates",
    "destinationPlaceName": "Dubai Park,,Dubai AE",
    "date": "2024-08-15",
    "time": "10:00",
    "passenger": "1"
  }
}'
`,
  php: `
<?php

$curl = curl_init();

$data = json_encode(array(
  "BookingDetails" => array(
    "sourceLat" => "25.248664",
    "sourceLng" => "55.352916",
    "destinationLat" => "25.228813942344",
    "destinationLng" => "55.28827531781",
    "sourcePlaceName" => "Dubai Airport (DXB),Dubai,United Arab Emirates",
    "destinationPlaceName" => "Dubai Park,,Dubai AE",
    "date" => "2024-08-15",
    "time" => "10:00",
    "passenger" => "1"
  )
));

curl_setopt_array($curl, array(
  CURLOPT_URL => 'https://testapi.drivado.com/api/v1/api/searchIdGenerateOneway?email=W1user1@email.com',
  CURLOPT_RETURNTRANSFER => true,
  CURLOPT_ENCODING => '',
  CURLOPT_MAXREDIRS => 10,
  CURLOPT_TIMEOUT => 0,
  CURLOPT_FOLLOWLOCATION => true,
  CURLOPT_HTTP_VERSION => CURL_HTTP_VERSION_1_1,
  CURLOPT_CUSTOMREQUEST => 'POST',
  CURLOPT_POSTFIELDS => $data,
  CURLOPT_HTTPHEADER => array(
    'apikey: iL9e30CjZfRok2FuH6KC1xuqCa7C3K',
    'Content-Type: application/json'
  ),
));

$response = curl_exec($curl);

curl_close($curl);
echo $response;
?>
`,
};


export const onewaypriceWithVehicleCodeImplementation = {
  nodejs_Axios: `
const axios = require('axios');

let config = {
  method: 'get',
  maxBodyLength: Infinity,
  url: 'https://testapi.drivado.com/api/v1/api/vehiclesWithPriceOneWay?searchId=SE-0824-FTIHE-OW&email=W1user1@email.com',
  headers: { 
    'apikey': 'iL9e30CjZfRok2FuH6KC1xuqCa7C3K'
  }
};

axios.request(config)
.then((response) => {
  console.log(JSON.stringify(response.data));
})
.catch((error) => {
  console.log(error);
});
`,
  python: `
import requests

url = "https://testapi.drivado.com/api/v1/api/vehiclesWithPriceOneWay?searchId=SE-0824-FTIHE-OW&email=W1user1@email.com"

headers = {
  "apikey": "iL9e30CjZfRok2FuH6KC1xuqCa7C3K"
}

response = requests.get(url, headers=headers)

print(response.json())
`,
  go: `
package main

import (
  "fmt"
  "io/ioutil"
  "net/http"
)

func main() {
  url := "https://testapi.drivado.com/api/v1/api/vehiclesWithPriceOneWay?searchId=SE-0824-FTIHE-OW&email=W1user1@email.com"
  req, _ := http.NewRequest("GET", url, nil)

  req.Header.Add("apikey", "iL9e30CjZfRok2FuH6KC1xuqCa7C3K")

  res, _ := http.DefaultClient.Do(req)

  defer res.Body.Close()
  body, _ := ioutil.ReadAll(res.Body)

  fmt.Println(string(body))
}
`,
  curl: `
curl --location --request GET 'https://testapi.drivado.com/api/v1/api/vehiclesWithPriceOneWay?searchId=SE-0824-FTIHE-OW&email=W1user1@email.com' \\
--header 'apikey: iL9e30CjZfRok2FuH6KC1xuqCa7C3K'
`,
  php: `
<?php

$curl = curl_init();

curl_setopt_array($curl, array(
  CURLOPT_URL => 'https://testapi.drivado.com/api/v1/api/vehiclesWithPriceOneWay?searchId=SE-0824-FTIHE-OW&email=W1user1@email.com',
  CURLOPT_RETURNTRANSFER => true,
  CURLOPT_ENCODING => '',
  CURLOPT_MAXREDIRS => 10,
  CURLOPT_TIMEOUT => 0,
  CURLOPT_FOLLOWLOCATION => true,
  CURLOPT_HTTP_VERSION => CURL_HTTP_VERSION_1_1,
  CURLOPT_CUSTOMREQUEST => 'GET',
  CURLOPT_HTTPHEADER => array(
    'apikey: iL9e30CjZfRok2FuH6KC1xuqCa7C3K'
  ),
));

$response = curl_exec($curl);

curl_close($curl);
echo $response;
?>
`,
};

export const onewayBookingWithVehicleCodeImplementation = {
  nodejs_Axios: `
const axios = require('axios');
let data = JSON.stringify({
  "vehicleId": "6426d4fd7cfcc6b82fc1c24e",
  "passengerDetails": {
    "firstname": "test",
    "lastname": "test",
    "email": "appdocstest@email.com",
    "phone": "6589455236",
    "country": "India",
    "dial_code": "+91",
    "flightOrTrain": "TK1372",
    "reference": "9978556897844",
    "specialRequest": "no special request"
  }
});

let config = {
  method: 'post',
  maxBodyLength: Infinity,
  url: 'https://testapi.drivado.com/api/v1/api/bookOW?searchId=SE-0824-FTIHE-OW&email=W1user1@email.com',
  headers: { 
    'apikey': 'iL9e30CjZfRok2FuH6KC1xuqCa7C3K', 
    'Content-Type': 'application/json'
  },
  data : data
};

axios.request(config)
.then((response) => {
  console.log(JSON.stringify(response.data));
})
.catch((error) => {
  console.log(error);
});
`,
  python: `
import requests
import json

url = "https://testapi.drivado.com/api/v1/api/bookOW?searchId=SE-0824-FTIHE-OW&email=W1user1@email.com"

payload = json.dumps({
  "vehicleId": "6426d4fd7cfcc6b82fc1c24e",
  "passengerDetails": {
    "firstname": "test",
    "lastname": "test",
    "email": "appdocstest@email.com",
    "phone": "6589455236",
    "country": "India",
    "dial_code": "+91",
    "flightOrTrain": "TK1372",
    "reference": "9978556897844",
    "specialRequest": "no special request"
  }
})
headers = {
  'apikey': 'iL9e30CjZfRok2FuH6KC1xuqCa7C3K',
  'Content-Type': 'application/json'
}

response = requests.request("POST", url, headers=headers, data=payload)

print(response.text)
`,
  go: `
package main

import (
  "bytes"
  "encoding/json"
  "fmt"
  "net/http"
)

func main() {
  url := "https://testapi.drivado.com/api/v1/api/bookOW?searchId=SE-0824-FTIHE-OW&email=W1user1@email.com"

  payload := map[string]interface{}{
    "vehicleId": "6426d4fd7cfcc6b82fc1c24e",
    "passengerDetails": map[string]string{
      "firstname": "test",
      "lastname": "test",
      "email": "appdocstest@email.com",
      "phone": "6589455236",
      "country": "India",
      "dial_code": "+91",
      "flightOrTrain": "TK1372",
      "reference": "9978556897844",
      "specialRequest": "no special request"
    }
  }
  jsonData, _ := json.Marshal(payload)

  req, _ := http.NewRequest("POST", url, bytes.NewBuffer(jsonData))
  req.Header.Set("apikey", "iL9e30CjZfRok2FuH6KC1xuqCa7C3K")
  req.Header.Set("Content-Type", "application/json")

  client := &http.Client{}
  resp, _ := client.Do(req)
  defer resp.Body.Close()

  var result map[string]interface{}
  json.NewDecoder(resp.Body).Decode(&result)

  fmt.Println(result)
}
`,
  curl: `
curl --location --request POST 'https://testapi.drivado.com/api/v1/api/bookOW?searchId=SE-0824-FTIHE-OW&email=W1user1@email.com' \\
--header 'apikey: iL9e30CjZfRok2FuH6KC1xuqCa7C3K' \\
--header 'Content-Type: application/json' \\
--data-raw '{
    "vehicleId": "6426d4fd7cfcc6b82fc1c24e",
    "passengerDetails": {
        "firstname": "test",
        "lastname": "test",
        "email": "appdocstest@email.com",
        "phone": "6589455236",
        "country": "India",
        "dial_code": "+91",
        "flightOrTrain": "TK1372",
        "reference": "9978556897844",
        "specialRequest": "no special request"
    }
}'
`,
  php: `
<?php

$curl = curl_init();

$data = json_encode(array(
  "vehicleId" => "6426d4fd7cfcc6b82fc1c24e",
  "passengerDetails" => array(
    "firstname" => "test",
    "lastname" => "test",
    "email" => "appdocstest@email.com",
    "phone" => "6589455236",
    "country" => "India",
    "dial_code" => "+91",
    "flightOrTrain" => "TK1372",
    "reference" => "9978556897844",
    "specialRequest" => "no special request"
  )
));

curl_setopt_array($curl, array(
  CURLOPT_URL => 'https://testapi.drivado.com/api/v1/api/bookOW?searchId=SE-0824-FTIHE-OW&email=W1user1@email.com',
  CURLOPT_RETURNTRANSFER => true,
  CURLOPT_ENCODING => '',
  CURLOPT_MAXREDIRS => 10,
  CURLOPT_TIMEOUT => 0,
  CURLOPT_FOLLOWLOCATION => true,
  CURLOPT_HTTP_VERSION => CURL_HTTP_VERSION_1_1,
  CURLOPT_CUSTOMREQUEST => 'POST',
  CURLOPT_POSTFIELDS => $data,
  CURLOPT_HTTPHEADER => array(
    'apikey: iL9e30CjZfRok2FuH6KC1xuqCa7C3K',
    'Content-Type: application/json'
  ),
));

$response = curl_exec($curl);

curl_close($curl);
echo $response;
?>
`,
};
